import {
    Anchor,
    Box,
    Grid,
    Group,
    Image,
    Paper,
    Text,
    Title
} from "@mantine/core";

import {AiOutlineLink} from "react-icons/ai";

const ApplicationLogoAnchor = ({application}: { application: { url: string, name: string, logo: string } }) => {
    return (
        <Anchor href={application.url} target="_blank">
            <Image src={application.logo} alt={application.name}/>
        </Anchor>
    )
}

const TitleAndDescription = ({application}: { application: { url: string, name: string, description: string } }) => {
    return (
        <>
            <Box style={{marginBottom: 'var(--mantine-spacing-lg)'}}>
                <Title order={3}
                       style={{color: 'var(--mantine-color-dark-7)'}}>
                    <Group>
                        <Text tt={'uppercase'}>{application.name}</Text>
                        <Anchor href={application.url} target="_blank">
                            <AiOutlineLink/>
                        </Anchor>
                    </Group>
                </Title>
            </Box>
            <Box>
                <Text>{application.description}</Text>
            </Box>
        </>
    )
}

// application tile component
export const ApplicationTile = ({
                                    application
                                }: {
    application: { name: string, description: string, logo: string, url: string, position: string }
}) => {

    switch (application.position) {
        case 'left':
            return (
                <Paper shadow="xl" p="xl" withBorder>
                    <Grid style={{padding: 'var(--mantine-spacing-xl)'}}>
                        <Grid.Col span={4} style={{
                            textAlign: 'center',
                            marginTop: '1em'
                        }}>
                            <ApplicationLogoAnchor application={application}/>
                        </Grid.Col>

                        <Grid.Col span={8}>
                            <TitleAndDescription application={application}/>
                        </Grid.Col>

                    </Grid>
                </Paper>
            )
        case 'right':
            return (
                <Paper shadow="xl" p="xl" withBorder>
                    <Grid style={{padding: 'var(--mantine-spacing-xl)'}}>

                        <Grid.Col span={8}>
                            <TitleAndDescription application={application}/>
                        </Grid.Col>

                        <Grid.Col span={4} style={{
                            textAlign: 'center',
                            marginTop: '1em'
                        }}>
                            <ApplicationLogoAnchor application={application}/>
                        </Grid.Col>
                    </Grid>
                </Paper>
            )
    }

}


